<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>როგორ შეგიძლია მართო ტოიოტა მარტივად?</h1>
    <h6>აგვისტო 2021</h6>
    <br />
    <p>
      დარწმუნებული ვარ, რომ სათაური უკვე საინტერესოდ ჟღერს. შოურუმში შესვლისას თვალის ერთი გადავლებითაც კი გრძნობ,
      რომელია „შენი ავტომობილი“, სუნთქვა გიჩქარდება, წარმოიდგენ საკუთარ თავს მის საჭესთან და შესაძლოა დამღლელ, მაგრამ
      მაინც სასიამოვნო გზებს, რომელსაც მასთან ერთად გაივლი. გონებაში თითქოს ყველაფერი ლაგდება: აუცილებლად უნდა იყიდო,
      თან, რაც შეიძლება სწრაფად, მაგრამ...როგორ?!
    </p>

    <p>
      შენი მაქსიმალური კომფორტისთვის თიბისი ლიზინგი და ტოიოტა კიდევ ერთხელ დამეგობრდნენ და შექმნეს სრულიად განსხვავებული
      სალიზინგო პროდუქტი, რომლით სარგებლობაც აქ. ახლა შეგიძლია.
    </p>
    <p class="solid-header" style="color: #EC1B2E; font-size: 44px">გაიცანი, TOYOTA EASY</p>

    <p class="solid-header" style="color: #4D4D4D; font-size: 44px">ახალი გზა - მართო მარტივად</p>

    <img src="../../../../assets/blog/toyota-easy/img1.jpg" alt="" />

    <p>
      განსხვავებული ფინანსური პროდუქტით, Toyota Easy-ით იღებ ექსკლუზიურ ფასს ტოიოტას ოფიციალურ დილერებთან. ამავდროულად,
      საოპერაციო მხარეს გიმარტივებთ და ზუსტად 1 საათში გიმტკიცებთ ლიზინგს. რა თქმა უნდა, წინასწარი შენატანი 0%-დან
      გავითვალისწინეთ და პროდუქტით სარგებლობის პერიოდიც 12-60 თვით განისაზღვრა. ეს ნიშნავს, რომ სარგებლობ ყველაზე დაბალ
      საპროცენტო განაკვეთით სალიზინგო პროდუქტებში და გარანტირებულია ნარჩენი ღირებულება.
      <br /><br />

      მოკლედ,
      <br /><br />

      <i class="subhead green"><b>ტოიტა იზის ძირითადი უპირატესობებია:</b></i>
      <br /><br />
      • სპეციალური ფასი ტოიოტას ავტომობილებზე <br />
      • 0%-იანი წინასწარი შენატანი <br />
      • დაბალი ყოველთვიური გადასახადი <br />
      • გარანტირებული ნარჩენი ღირებულება <br />
      • მუდმივად ახალი, გარანტიაზე მყოფი ავტომობილი <br />
    </p>

    <img src="../../../../assets/blog/toyota-easy/img2.jpg" alt="" />

    <p>
      მათთვის, ვისთვისაც ეს პირობები უკვე მიმზიდველია, მაგრამ კიდევ უფრო მეტი ბენეფიტის მიღება სურს, Toyota Easy Flex
      შევქმენით. პროდუქტი გარდა ზემოთ ჩამოთვლილი სარგებლებისა, თრეიდ - ინ ფუნქციას და დამატებით ფასდაკლებას მოიცავს
      სერვისებზე. სარგებლობის პერიოდი: 3-72 თვეა.
      <br /><br />

      <i class="subhead light-blue"><b>ანუ, კონტრაქტის დასრულების შემდეგ შენ შეგიძლია:</b></i>
      <br /><br />
      1. შეინარჩუნო ავტომობილი და განაგრძო მისი მართვა, რისთვისაც მხოლოდ წინასწარ განსაზღვრულ ნარჩენ ღირებულებას
      გადაიხდი.
      <br />
      2. დააბრუნო ავტომობილი სერვის ცენტრში. <br />
      3. განაახლო ავტომობილი, რისთვისაც ძველის დატოვება მოგიწევს სერვის-ცენტრში.
    </p>

    <img src="../../../../assets/blog/toyota-easy/img3.jpg" alt="" />

    <p>
      ახალი ფინანსური პროდუქტი გთავაზობს არა მხოლოდ მართო ტოიოტა მარტივად, არამედ სწრაფად, კომფორტულად და მოქნილად მიიღო
      შენს ცხოვრებაში ერთ-ერთი ყველაზე სასიამოვნო გადაწყვეტილება - ისარგებლო ლიზინგით.
    </p>

    <p style="color: #999999">ავტორი: ლალიკო თუმანიშვილი</p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>How to Drive a Toyota Easily?</h1>
    <h6>August 2021</h6>
    <br />
    <p>
      I’m sure the title already sounds intriguing. When you enter a showroom, just by taking a quick glance, you can
      feel which car is "yours," your breath quickens, and you imagine yourself behind its wheel, possibly on long but
      still enjoyable journeys that you’ll take together. In your mind, everything seems to fall into place: you must
      buy it, and quickly, but... how?
    </p>

    <p>
      For your maximum comfort, TBC Leasing and Toyota have once again teamed up to create a completely different
      leasing product, and you can benefit from it here. Now.
    </p>

    <p class="solid-header" style="color: #EC1B2E; font-size: 44px">Meet TOYOTA EASY</p>

    <p class="solid-header" style="color: #4D4D4D; font-size: 44px">A New Way – Drive Easily</p>

    <img src="../../../../assets/blog/toyota-easy/img1.jpg" alt="" />

    <p>
      With the unique financial product, Toyota Easy, you get an exclusive price from Toyota’s official dealers. At the
      same time, the operational side is simplified, and your leasing will be approved in exactly 1 hour. Of course,
      we’ve taken into account an initial contribution starting from 0%, and the leasing term is set between 12 to 60
      months. This means that you enjoy the lowest interest rates in leasing products, and a residual value is
      guaranteed.
      <br /><br />

      მოკლედ,
      <br /><br />

      <i class="subhead green"><b>In short, Toyota Easy's main advantages are:</b></i>
      <br /><br />
      • Special price on Toyota vehicles <br />
      • 0% initial payment <br />
      • Low monthly payments<br />
      • Guaranteed residual value <br />
      • Always a new, warranty-covered vehicle <br />
    </p>

    <img src="../../../../assets/blog/toyota-easy/img2.jpg" alt="" />

    <p>
      For those who already find these conditions attractive but want to receive even more benefits, we’ve created
      Toyota Easy Flex. In addition to the benefits mentioned above, this product also includes a trade-in feature and
      additional discounts on services. The usage period ranges from 3 to 72 months.
      <br /><br />

      <i class="subhead light-blue"><b>So, after the contract ends, you can:</b></i>
      <br /><br />
      1. Keep the vehicle and continue driving it by paying only the pre-determined residual value.
      <br />
      2. Return the vehicle to the service center.<br />
      3. Exchange the vehicle for a new one, leaving the old one at the service center.
    </p>

    <img src="../../../../assets/blog/toyota-easy/img3.jpg" alt="" />

    <p>
      This new financial product offers not just an easy way to drive a Toyota, but also the chance to make one of the
      most enjoyable decisions in your life quickly, comfortably, and flexibly – by leasing.
    </p>

    <p style="color: #999999">Author: Laliiko Tumanishvili</p>
  </div>
</ng-container>
